import { render, staticRenderFns } from "./TabGroup.vue?vue&type=template&id=d76e9fc2&"
import script from "./TabGroup.vue?vue&type=script&lang=js&"
export * from "./TabGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports